var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"align-self-start"},[_c('v-row',[_c('v-col',{staticClass:"mb-4",attrs:{"cols":"12","lg":"3"}},[_c('FilterSoilTable')],1),_c('v-col',{attrs:{"cols":"12","lg":"9"}},[_c('SoilTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }